// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__pZGvh","container":"Footer_container__YyWFv","privacy":"Footer_privacy__23gji","poweredBy":"Footer_poweredBy__2zpxT"};